<template lang="pug">
div#mc_embed_shell
  div#mc_embed_signup
    form#mc-embedded-subscribe-form.validate(
      :action="actionUrl"
      method="post"
      name="mc-embedded-subscribe-form"
      target="_blank"
    )
      div.d-flex.flex-column.flex-lg-row.align-items-center.justify-content-end.gap-2
        div.mc-field-group
          input#mce-EMAIL.required.email(
            type="email"
            name="EMAIL"
            required=""
            :placeholder="placeholder"
            :style="inputStyles"
          )
        div#mce-responses.clear
          div#mce-error-response.response(style="display: none")
          div#mce-success-response.response(style="display: none")
        div(aria-hidden="true" style="position: absolute; left: -5000px")
          input(
            type="text"
            name="b_25b4f1ea4762d563afe0f3f1c_bab438f6fb"
            tabindex="-1"
            value=""
          )
        div.clear
          input#mc-embedded-subscribe.button(
            type="submit"
            name="subscribe"
            :value="buttonText"
            :style="buttonStyles"
          )
</template>

<script>
import mixins from 'common/mixins'

export default {
  name: 'mailchimp-subscription-vue',
  mixins: [mixins.translate],
  props: {
    placeholder: {
      type: String,
      default: 'Déjanos tu email'
    },
    buttonText: {
      type: String,
      default: 'ENVIAR'
    }
  },
  data() {
    return {
      actionUrl: 'https://tirant.us8.list-manage.com/subscribe/post?u=25b4f1ea4762d563afe0f3f1c&id=bab438f6fb&f_id=00287ae0f0',
      inputStyles: {
        border: '1px solid #b5b5b5',
        borderRadius: '500px',
        padding: '7px 25px'
      },
      buttonStyles: {
        borderRadius: '500px',
        border: '1px solid #ef753c',
        backgroundColor: '#ef753c',
        color: '#FFF',
        padding: '7px 25px'
      }
    }
  },
  mounted() {
    this.loadMailchimpScript()
  },
  methods: {
    loadMailchimpScript() {
      // Cargar el script de validación de Mailchimp
      if (!document.querySelector('script[src*="mc-validate.js"]')) {
        const script = document.createElement('script')
        script.src = '//s3.amazonaws.com/downloads.mailchimp.com/js/mc-validate.js'
        script.onload = () => {
          this.initializeMailchimp()
        }
        document.head.appendChild(script)
      } else {
        this.initializeMailchimp()
      }
    },
    initializeMailchimp() {
      // Inicializar la validación de Mailchimp
      if (typeof window.jQuery !== 'undefined' && window.jQuery) {
        window.fnames = new Array()
        window.ftypes = new Array()
        window.fnames[0] = 'EMAIL'
        window.ftypes[0] = 'email'
        window.fnames[1] = 'FNAME'
        window.ftypes[1] = 'text'
        window.fnames[2] = 'LNAME'
        window.ftypes[2] = 'text'
        window.fnames[3] = 'ADDRESS'
        window.ftypes[3] = 'address'
        window.fnames[4] = 'PHONE'
        window.ftypes[4] = 'phone'
      }
    }
  }
}
</script>

<style scoped>
#mc_embed_signup {
  background: transparent;
  clear: left;
}

.mc-field-group input {
  border: 1px solid #b5b5b5;
  border-radius: 500px;
  padding: 7px 25px;
}

#mc-embedded-subscribe {
  border-radius: 500px;
  border: 1px solid #ef753c;
  background-color: #ef753c;
  color: #FFF;
  padding: 7px 25px;
  cursor: pointer;
}

#mc-embedded-subscribe:hover {
  background-color: #d85a2a;
  border-color: #d85a2a;
}
</style>